import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'

import Loader from 'components/Loader'

const Alertas = lazy(async () => import('./Alertas/ClientesAlertas'));

export default function ClientesPropios({ match }: any) {
  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
              <Route  path={`${match.url}/alertas`} component={Alertas}/>
        </Suspense>
      </Switch>
    </div>
  )
}
